import { _regxp } from '@/plugins/Utils';

export default {
	computed: {
		regex: function() {
			return _regxp();
		},
	},
};
